import { render, staticRenderFns } from "./TenantDetails.vue?vue&type=template&id=1b71e863&scoped=true"
import script from "./TenantDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TenantDetails.vue?vue&type=style&index=0&id=1b71e863&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71e863",
  null
  
)

export default component.exports